import axios from "axios";

const tokenMock = 656565;

export const apiMerchant = axios.create({
  baseURL: process.env.REACT_APP_API_MERCHANT,
});

const setHeaders = (config) => {
  config.headers.Authorization = `Bearer ${tokenMock}`;
  return config;
};

const rejectPromise = (error) => Promise.reject(error);

apiMerchant.interceptors.request.use(setHeaders, rejectPromise);
